export const niftichat = () => {
  window.addEventListener('load', () => {
    setTimeout(() => {
      // Ensure the iframe/script is only loaded once
      if (window.niftichatLoaded) return;

      window.niftichatLoaded = true;

      // Create the script element
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widgets.leadconnectorhq.com/loader.js';
      s.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
      s.setAttribute('data-widget-id', '66e316ca41636c45c53127a3');

      // Insert the script before the first script tag in the document
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);

      console.log('Niftichat script initialized');
    }, 3200); // Wait for 3 seconds after the page has fully loaded
  });
};